import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CenovnikTableComponent } from './cenovnik-table/cenovnik-table.component';

const routes: Routes = [
  {
    path: '',
    component: CenovnikTableComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class CenovnikRoutingModule {}
